export class SiteDetails {
  SiteID: string;
  WorklifePath: string;
  ApiPath: string;
  AdminPath: string;
  ErPortalPath: string;
  ErPortalApiPath: string;
}
